// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq[data-v-484c6e34]{border-radius:1rem}.faq .montserrat-currency[data-v-484c6e34],.faq[data-v-484c6e34] .montserrat-currency{font-family:Open Sans,sans-serif}.faq[data-v-484c6e34] a,.faq[data-v-484c6e34] button{text-decoration:underline;font-style:italic;--text-opacity:1;color:#1d4ed8;color:rgba(29,78,216,var(--text-opacity));cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
